module.exports = __webpack_public_path__ + "img/image50.17ac8c03.png";